module.exports = __webpack_public_path__ + "static/media/remove_icon.350e356b.svg";